// export const api = "https://universitysolutions.in/collportal/app.php?a=";

export const API = "https://universitysolutions.in/tdvs-php";

export const abpath =
  "https://answer-booklets.s3.ap-south-1.amazonaws.com/eval-img/";
